import { createEffect } from "effector";
import { toast } from "react-toastify";


export const showErrorToastFx = createEffect<string, void>({
  handler: (message) => {
    toast.error(message, { containerId: 'toasts__container' });
  },
});